import { CollectionImage } from '~/components/collections';
import { RewardType } from '~/shared';
import { StyledContainer, StyledDotsContainer } from './OpenCaseItem.styled';

interface IOpenCaseItem {
	type: RewardType;
	image: string;
	color: string;
}

const OpenCaseItem = ({ type, image, color }: IOpenCaseItem) => {
	return (
		<StyledContainer $color={color}>
			<StyledDotsContainer />
			{type === RewardType.VEHICLE ? (
				<CollectionImage collection={'vehicles'} id={image} size={96} />
			) : (
				<img src={image} />
			)}
			<div className="line" />
		</StyledContainer>
	);
};

export { OpenCaseItem };
